<template>
    <div class="home-box">
        <div class="home-container">
          <div class="home-banner">
              <swiper :options="swiperOption" ref="mySwiper" @someSwiperEvent="callback">
                  <!-- slides -->
                  <swiper-slide :style="{backgroundImage:'url('+imgurl3+')'}"></swiper-slide>
                  <swiper-slide :style="{backgroundImage:'url('+imgurl4+')'}"></swiper-slide>
                  <!-- Optional controls -->
                  <div class="swiper-button-prev" slot="button-prev"></div>
                  <div class="swiper-button-next" slot="button-next"></div>
              </swiper>
              <div class="swiper-pagination"  slot="pagination"></div>
              <div class="common-content">
                  <h2>Grand Channel Inc</h2>
                  <h3>E-Commerce Warehousing Solutions</h3>
                  <p>
                    <span>LEARN MORE</span>
                    <span class="active">GET IN TOUCH</span>
                  </p>
              </div>
              <div class="home-tool">
                <ul>
                  <li><span>Cost-Efficiency</span></li>
                  <li><span>Handy System</span></li>
                  <li><span>Large Capacity</span></li>
                  <li><span>Timely Line Haul</span></li>
                </ul>
              </div>
              <div class="home-service">
                  <h3><span>Warehouse Service</span></h3>
                  <ul>
                    <li><span>E-Fulfillment</span></li>
                    <li><span>FBA Forwarding</span></li>
                    <li><span>Distribution</span></li>
                    <li><span>Customized Service</span></li>
                  </ul>
              </div>
              <div class="home-intro">
                  <h3><span>Grand Channel Inc</span></h3>
                  <h4>Overseas E-Commerce Warehousing Solutions </h4>
                  <div>
                    <p>Located in South California, west coast of USA, Grand Channel is a rapidly growing professional e-commerce warehouse specializes in providing high-quality
overseas e-commerce warehousing solutions, helping customers get free from the hassle of handling inventory. </p>
                    <p>With the rapid development of economic globalization, Cross-Border E-Commerce (CBEC) gradually becomes one of the most important parts on Online to
Offline (O2O) platform. Meanwhile, increasingly detailed market segmentations is driving e-commerce industry more specialized, making e-commerce
merchants possible to shake all offline parts such as export, forwarding, bulky inventory and shipment off. </p>
                    <p>For all kinds of CBEC customers, Grand Channel provides 360° all aspects overseas-stocking inventory care. Here in our 192,000 square feet facility in California,
USA, we provide standard warehousing service, including FBA Forwarding, Online Order E-Fulfillment and Distribution services. Besides, Grand Channel is also
experienced in solution customizing: You tell us your story; We do warehousing for you and save your time.</p>
                    <p>Service quality is paramount, and customer satisfaction is our priority. Stay with us to make yourself one of e-commerce winners who have already got rid of
inventory and only focus on growing their online business!</p>
                  </div>
                  <p>
                    <span>LEARN MORE</span>
                    <span class="active">GET IN TOUCH</span>
                  </p>
              </div>
          </div>
        </div>
    </div>
</template>

<script>
  import 'swiper/dist/css/swiper.css'
  import { swiper, swiperSlide } from 'vue-awesome-swiper'

  export default {
    name: 'home',
    data () {
      return {
        swiperOption: {
          slidesPerView: 'auto',
          loopedSlides:3,
          effect : 'slide', //slide的切换效果，默认为"slide"（位移切换），可设置为'slide'（普通切换、默认）,"fade"（淡入）"cube"（方块）"coverflow"（3d流）"flip"（3d翻转）。
          direction : 'horizontal',//Slides的滑动方向，可设置水平(horizontal)或垂直(vertical)。
          loop:true,//循环
          centeredSlides: true,//
          speed:800, //滚动速度
          autoplay: {
            delay: 5000,//自动切换的时间间隔
            disableOnInteraction: false //用户操作swiper之后，是否禁止autoplay。
          },
          mousewheel: false, //开启鼠标滚轮控制Swiper切换
          pagination: {
            el: '.swiper-pagination',//分页器容器的css选择器或HTML标签。。
            clickable: true//此参数设置为true时，点击分页器的指示点分页器会控制Swiper切换。
          },
          navigation: {
            nextEl: '.swiper-button-next',//前进按钮的css选择器或HTML元素。
            prevEl: '.swiper-button-prev'//后退按钮的css选择器或HTML元素。
          }
        },
        imgurl1:require('../../assets/images/home/div_ppt1.png'),
        imgurl2:require('../../assets/images/home/div_ppt2.png'),
        imgurl3:require('../../assets/images/home/div_ppt3.png'),
        imgurl4:require('../../assets/images/home/div_ppt4.png'),
      }
    },
    components:{
      swiper,
      swiperSlide
    },
    methods:{
      callback(){

      }
    },
    computed:{
      swiper() {
        return this.$refs.mySwiper.swiper
      }
    },
    mounted(){
      this.swiper.slideTo(3, 1000, false)
    },
    watch:{
      // 如果 `某个属性` 发生改变，这个属性对应的函数就会运行
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
    .home-box {
      background-size:cover;
      width:100%;
      margin-top: -12px;

      .home-container {
        width:100%;
        height:100%;

        .home-banner {
            position:relative;
            .common-content{
              position:absolute;
              top: 300px;
              left: 50%;
              width:500px;
              height:400px;
              margin-top:-200px;
              margin-left: -250px;
              z-index:10000;
              h2 {
                font-size:50px;
                color:#fff;
                position:absolute;
                top: 32%;
                left:50%;
                margin-left:-210px;
                font-weight: bold;
              }
              h3 {
                font-size:18px;
                color:#fff;
                position:absolute;
                top: 50%;
                left:50%;
                margin-left:-150px;
              }
              p {
                width:420px;
                position:absolute;
                top: 65%;
                left:50%;
                margin-left:-210px;
                span {
                  display:block;
                  float:left;
                  width:180px;
                  height:40px;
                  line-height:40px;
                  text-align: center;
                  border:solid 2px #4D8D90;
                  color:#fff;
                  font-size:16px;
                  cursor: pointer;
                  &:hover,&.active {
                    background:#4D8D90;
                  }
                  &:nth-of-type(1){
                    margin-right:50px;
                  }
                  &:nth-of-type(2){

                  }
                }
              }
            }
            .swiper-container {
              height:600px;
            }
            .swiper-pagination {
              width:100px;
              left: 50%;
              margin-left: -50px;
              top: 500px;
              z-index:11;
            }

            .home-tool {
                width:100%;
                height:800px;
                background: url('../../assets/images/home/wave-top.png') no-repeat left top,
                            url('../../assets/images/home/wave-bottom.png') no-repeat left bottom;
                background-size:100% auto;
                position:relative;
                top: -130px;
                z-index:10;
                padding-top: 300px;

                ul {
                  display:block;
                  width:850px;
                  margin:auto;
                  overflow:hidden;
                  li {
                    display:block;
                    width:120px;
                    height:180px;
                    margin-right:120px;
                    float:left;
                    position:relative;
                    span {
                      position:absolute;
                      bottom:0;
                      text-align:center;
                      display:block;
                      width:100%;
                      color:#0B4FAA;
                      font-size:14px;
                    }
                    &:nth-of-type(1){
                      background:url('../../assets/images/home/c1.png') no-repeat center;
                      background-size:100% auto;
                    }
                    &:nth-of-type(2){
                      background:url('../../assets/images/home/c2.png') no-repeat center;
                      background-size:100% auto;
                    }
                    &:nth-of-type(3){
                      background:url('../../assets/images/home/c3.png') no-repeat center;
                      background-size:100% auto;
                    }
                    &:nth-of-type(4){
                      margin-right:0;
                      background:url('../../assets/images/home/c4.png') no-repeat center;
                      background-size:100% auto;
                    }
                  }
                }
            }

            .home-service {
              height:400px;
              width:100%;
              background:url('../../assets/images/home/c5.png') no-repeat center top;
              position:relative;
              z-index:9;
              top:-200px;
              padding-top:100px;
               h3 {
                font-size:30px;
                color:#0965A4;
                height:40px;
                text-align:center;
                width:600px;
                margin:auto;
                border-bottom: solid 1px #CBD1D6;
               }
               ul {
                width:1200px;
                display:block;
                margin:auto;
                overflow:hidden;
                height:120px;
                margin-top:60px;
                li {
                  float:left;
                  width:20%;
                  height:100%;
                  margin-right:6%;
                  position:relative;
                  &:nth-of-type(1){
                    background:url('../../assets/images/home/d1.png') no-repeat center;
                    background-size:100% 100%;
                  }
                  &:nth-of-type(2){
                    background:url('../../assets/images/home/d2.png') no-repeat center;
                    background-size:100% 100%;
                  }
                  &:nth-of-type(3){
                    background:url('../../assets/images/home/d3.png') no-repeat center;
                    background-size:100% 100%;
                  }
                  &:nth-of-type(4){
                    background:url('../../assets/images/home/d4.png') no-repeat center;
                    background-size:100% 100%;
                  }
                  &:nth-of-type(4){
                    margin-right:0;
                  }
                  span {
                    color:#fff;
                    font-size:24px;
                    width:100%;
                    height:100%;
                    vertical-align: middle;
                    line-height:30px;
                    text-align:center;
                    background:rgba(0,0,0,0.5);
                    display: flex;
                    align-items: center;
                    justify-content: space-around;
                    flex-direction: column;
                    position:absolute;
                    top:120px;
                    -webkit-transition: all .5s ease;
                       -moz-transition: all .5s ease;
                        -ms-transition: all .5s ease;
                         -o-transition: all .5s ease;
                            transition: all .5s ease;
                  }
                  &:hover {
                    span {
                      top: 0;
                    }
                  }
                }
               }
            }

            .home-intro {
              width:1000px;
              margin:auto;
              margin-top:-100px;
              padding-bottom: 200px;
              position:relative;
              h3 {
                font-size:30px;
                color:#0965A4;
                height:40px;
                text-align:center;
              }
              h4 {
                font-size:16px;
                color:#048EEC;
                height:40px;
                text-align:center;
              }
              div {
                margin-top:20px;
                p {
                  margin-bottom: 20px;
                  text-indent:2rem;
                  color:#777777;
                  font-size:14px;
                }
              }
              >p {
                width:420px;
                position:absolute;
                left:50%;
                margin-left:-210px;
                top: 76%;
                span {
                  display:block;
                  float:left;
                  width:180px;
                  height:40px;
                  line-height:40px;
                  text-align: center;
                  border:solid 2px #048EEC;
                  color:#048EEC;
                  font-size:16px;
                  cursor: pointer;
                  &:hover,&.active {
                    background:#048EEC;
                    color:#fff;
                  }
                  &:nth-of-type(1){
                    margin-right:50px;
                  }
                  &:nth-of-type(2){

                  }
                }
              }
            }
        }
      }
    }
</style>
<style type="text/css">
  .swiper-pagination-bullet {
    float: left;
    display:block;
    width:10px;
    height: 10px;
    margin-right: 10px;
    background-color:#fff;
    opacity:1;
    outline:none;
  }
  span.swiper-pagination-bullet-active {
      background: #007aff;
  }
  .swiper-slide {
    background-repeat: no-repeat;
    background-position: center;
    background-size:100% 100%;
  }
</style>



// WEBPACK FOOTER //
// src/views/home/home.vue